export enum EROLE {
  OWNER = "OWNER",
  EDITOR = "EDITOR",
  REPORTER = "REPORTER",
}
